module.exports = __webpack_public_path__ + "static/media/email-comp.1c13ca5f.jpg";